<template>
  <div>
    <app-content>
      <h1>Skills</h1>
    </app-content>
    <div class="skills-wrapper">
      <app-content>
        <skill-cards :skills="sortedSkills" />
        <!-- <div class="skill-card-wrapper">
          <div class="skill-card" v-for="skill in sortedSkills" :key="skill.id">
            <div class="skill-circle">
              <level-circle :name="skill.name" :percentage="skill.percentage" size="150" />
            </div>
          </div>
        </div> -->
      </app-content>
    </div>
    <app-content>
      <div class="skills-caption">
        ※25%で入門, 50%で簡単なプログラムの開発, 75%で作りたいものが開発できるぐらいの習得度を表しています。
      </div>
      <div class="contact-link">
        <leading-link to="/contact" size="32">Contact</leading-link>
      </div>
    </app-content>
  </div>
</template>

<script>
import AppContent from 'src/components/AppContent'
import LeadingLink from 'src/components/LeadingLink'
import SkillCards from './components/SkillCards'
import data from './data'

export default {
  data: () => {
    return {
      ...data
    }
  },
  computed: {
    sortedSkills() {
      const compareFunction = (skill1, skill2) => {
        return skill2.percentage - skill1.percentage
      }
      return Object.assign([], this.skills).sort(compareFunction)
    }
  },
  components: {
    AppContent,
    LeadingLink,
    SkillCards
  }
}
</script>

<style scoped>
.skills-wrapper {
  display: flex;
  background-color: rgb(224, 224, 224);
}

.contact-link {
  display: flex;
  margin-top: 64px;
  margin-bottom: 64px;
  justify-content: center;
}
</style>
